import styled from "styled-components";

export const AppliedFiltersSection = styled.div`
  background-color: #f3f2f1;
  padding: 11px;
  margin-top: 45px;

  .selected-filters-title {
    margin-bottom: 5px;
  }
  .applied-filters {
    button {
      border: 0;
      background: transparent;
      color: black;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .clear-all-button {
    border: 0;
    background: transparent;
    margin-top: 10px;
    &:hover {
      text-decoration: underline;
    }
  }
  @media (max-width: 991px) {
    &.desktop-filters {
      display: none;
    }
  }
  @media (min-width: 992px) {
    &.mobile-filters {
      display: none;
    }
  }
`